import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortenNumber',
  standalone: true,
})
export class ShortenNumberPipe implements PipeTransform {
  transform(
    value: number,
    displayShortFormatPrice: boolean,
    langTag: string,
    options: Intl.NumberFormatOptions | { [key: string]: any },
  ): any {
    const formatter = Intl.NumberFormat(langTag, options);
    const roundedValue = this.roundedValue(value, 2);
    options = {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    };
    const completePrice = roundedValue.toLocaleString(langTag, options);
    return !displayShortFormatPrice ? completePrice : formatter.format(value).toLocaleUpperCase(langTag);
  }

  roundedValue(value: string | number, decimals: string | number) {
    return Number(Math.round(Number(value + 'e+' + decimals)) + 'e-' + decimals);
  }
}
